import React from 'react';

const commonList = (props) => (
    <ul className={`u-textColorDark`} style={{ listStylePosition: 'inside' }}>
        {props.children}
    </ul>
);

export default commonList;


// WEBPACK FOOTER //
// ./src/components/Payment/Common/CommonList/CommonList.js